import humanize from '../../shared/utils/humanize';
import normalizeChoices from '../utils/normalizeChoices';
import buildBooleanChoices from '../utils/buildBooleanChoices';
import coerceValueToBoolean from '../utils/coerceValueToBoolean';
import { FIXTURES, mergeNeedsFixture } from '../fixtures';

import type { App, Need, NeedResponse, Action } from '../types';

const buildNeeds = (
  needs: NeedResponse[],
  selectedApi: App['selected_api'],
  actionKey: Action['key'],
  readActions: Action[] = []
): Need[] =>
  mergeNeedsFixture(FIXTURES, selectedApi, actionKey, needs).map(
    (needResponse) => {
      const need: Need = {
        ...needResponse,
        // Generate labels for needs that don't have one by humanizing the key
        label: needResponse.label || humanize(needResponse.key),
        // Normalize all the various types of choices.
        choices: needResponse.choices && normalizeChoices(needResponse.choices),
        // Indicate whether the need can paginate prefill choices.
        prefill_can_paginate: !!(
          needResponse.prefill &&
          readActions.find(
            ({ key }) => key === (needResponse.prefill || '').split('.')[0]
          )?.meta?.poll?.can_paginate
        ),
      };
      // Covert boolean fields into two choices
      if (need.type === 'bool' || need.type === 'boolean') {
        need.choices = buildBooleanChoices(need);
        need.default = coerceValueToBoolean(need.default);
      }
      return need;
    }
  );

export default buildNeeds;
